import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { BatchNotifyRequest } from "./shared/batch-notify-request";
import { BatchNotifySelectRequest } from "./shared/batch-notify-select-request";
import { DataService_PortalAppBatchNotify } from "./shared/data.service";

@Component({
	selector: "caass-portal-app-notifications",
	templateUrl: "./portal-app-notifications.component.html",
	styleUrls: ["./portal-app-notifications.component.css"],
})
export class PortalAppNotificationsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_PortalAppBatchNotify,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////

	subscription: any;

	PersonTypeID: number = -1;

	SelectedSchool: any;
	SchoolSelectShowAllText: any = "All Schools";

	GradeLevelID: number = -1;
	AcademyID: number = -1;
	HomeroomID: number = -1;
	GroupID: number = -1;
	Criteria: string = "";
	Message: string = "";

	lstGradeLevel: any = [];
	lstAcademy: any = [];
	lstGroup: any = [];
	lstHomeroom: any = [];
	lstPersonType: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Student",
		},
		{
			ID: 2,
			Desc: "Staff",
		},
	];

	LoadingGradeLevel: boolean = false;
	LoadingAcademy: boolean = false;
	LoadingGroup: boolean = false;
	LoadingHomeroom: boolean = false;
	LoadingTable: boolean = false;
	Processing: boolean = false;

	SendToParent: boolean = true;
	SendToStudent: boolean = true;
	SendToStaff: boolean = true;

	ErrorMessage: string = "";

	pagerows: any = 10;
	pagefirst: any = 0;
	lstTable: any = [];
	SelectedRegUsers: any = [];

	lstAppTypeDesc: any = [];
	lstSchoolName: any = [];

	cols: any = [
		{ field: "ID", header: "ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "AppTypeDesc", header: "App" },
		{ field: "SchoolName", header: "School" },
		{ field: "UserID_Email", header: "User" },
		{ field: "UserFirstName", header: "User First Name" },
		{ field: "UserLastName", header: "User Last Name" },
	];

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.dataService.loadGradeLevelList("", this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All",
					});
				}

				this.GradeLevelID = this.lstGradeLevel[0].GradeLevelID;

				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.dataService.loadHomeroomList("", this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All",
					});
				}

				this.HomeroomID = this.lstHomeroom[0].HomeroomId;

				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.dataService.loadAcademyList("", this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All",
					});
				}

				this.AcademyID = this.lstAcademy[0].AcademyId;

				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.dataService.loadGroupList("", this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All",
					});
				}

				this.GroupID = this.lstGroup[0].GroupID;

				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////

	onSearch() {
		this.ErrorMessage = "";
		this.SelectedRegUsers = [];

		var parms: BatchNotifySelectRequest = {
			PersonType: this.PersonTypeID,
			SchoolID: this.SelectedSchool.SchoolID,
			GradeLevelID: this.PersonTypeID == 1 ? this.GradeLevelID : -1,
			AcademyID: this.PersonTypeID == 1 ? this.AcademyID : -1,
			HomeroomID: this.PersonTypeID == 1 ? this.HomeroomID : -1,
			GroupID: this.PersonTypeID == 1 ? this.GroupID : -1,
			Criteria: this.Criteria,
		};

		this.LoadingTable = true;

		var result = this.dataService.BatchNotifySelectList(parms);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				this.lstAppTypeDesc = Array.from(new Set(this.lstTable.map((item: any) => item.AppTypeDesc))).sort();
				this.lstSchoolName = Array.from(new Set(this.lstTable.map((item: any) => item.SchoolName))).sort();

				this.LoadingTable = false;
			},
			(error) => {
				this.LoadingTable = false;
			}
		);
	}

	onSend() {
		var lstPIDs: number[] = this.SelectedRegUsers.map((item) => item.PersonID);

		if (lstPIDs == undefined || lstPIDs.length == 0) {
			this.ErrorMessage = "Select students or staff to message";
			return;
		}

		var parms: BatchNotifyRequest = {
			Message: this.Message,
			SendToParent: this.SendToParent,
			SendToStudent: this.SendToStudent,
			SendToStaff: this.SendToStaff,
			lstPersonIDs: lstPIDs,
		};

		this.Processing = true;

		var result = this.dataService.BatchNotify(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "batchnotify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Notification was sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.Message = "";
							this.SelectedRegUsers = [];
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "batchnotify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send the notification: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	onRowSelect(val) {
		// this.SelectedRegUser = val.data;
	}
	onRowUnselect(val) {
		// this.SelectedRegUser = null;
	}

	/////////////////////////////////////////////////

	/////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////

	IsLoading() {
		return (
			this.LoadingGradeLevel == true ||
			this.LoadingAcademy == true ||
			this.LoadingGroup == true ||
			this.LoadingHomeroom == true ||
			this.Processing == true
		);
	}

	GetParentCount(): number {
		var ans = 0;

		for (var z = 0; z < this.SelectedRegUsers.length; z++) {
			var next = this.SelectedRegUsers[z];
			if (next.RegAppTypeID == 1) {
				ans++;
			}
		}

		return ans;
	}

	GetStudentCount(): number {
		var ans = 0;

		for (var z = 0; z < this.SelectedRegUsers.length; z++) {
			var next = this.SelectedRegUsers[z];
			if (next.RegAppTypeID == 2) {
				ans++;
			}
		}

		return ans;
	}

	GetStaffCount(): number {
		var ans = 0;

		for (var z = 0; z < this.SelectedRegUsers.length; z++) {
			var next = this.SelectedRegUsers[z];
			if (next.RegAppTypeID == 3) {
				ans++;
			}
		}

		return ans;
	}

	/////////////////////////////////////////////////
}
